import { Button, Card, Dialog, Input, Radio, Switch } from '@alifd/next';
import { EditOutlined } from '@ant-design/icons';
import { Form, message, Select, Table, TimePicker } from 'antd';
import axios from 'axios';
import { history } from 'ice';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const { Option } = Select;
const BroadCastBoxList = () => {
  // 獲取redux user資料
  const user = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const selectedValue = Form.useWatch('category', form); // 監聽 radioGroup
  const broadcast = client.service('broadcast');
  const broadcastBox = client.service('broadcastBoxs');
  const baDevice = client.service('baDevice');
  const communityData = client.service('communityData');

  const [broadcastBoxData, setBroadcastBoxData] = useState([]);
  const [addBroadcastBox, setAddBroadcastBox] = useState(false);
  const [editBroadcastBox, setEditBroadcastBox] = useState(false);
  const [broadcastBoxStatus, setBroadcastBoxStatus] = useState('insert');
  const [broadcastData, setBroadcastData] = useState([]);
  const [addBroadcastDialog, setAddBroadcastDialog] = useState(false);
  const [broadcastBoxId, setBroadcastBoxId] = useState();
  const [addBroadcast, setAddBroadcast] = useState();
  const [baDeviceData, setBaDeviceData] = useState([]);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [onUrgent, setOnUrgent] = useState(false);
  const [urgentData, setUrgentData] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [onInteraction, setOnInteraction] = useState(false);

  // console.log(selectedValue);
  useEffect(() => {
    try {
      (async () => {
        const broadcastBoxData = await broadcastBox.find({});

        setBroadcastBoxData(
          broadcastBoxData.data.sort((a, b) => b.createdTime - a.createdTime)
        );
        const broadcastData = await broadcast.find({});
        setBroadcastData(broadcastData.data);
        const baDeviceData = await baDevice.find({
          query: { category: '門禁' },
        });
        setBaDeviceData(baDeviceData.data);
        const community = await communityData.find({});
        setCommunityDataArr(community.data[0]);
      })();
    } catch (error) {
      console.error(error);
    }
  }, [broadcastBox, broadcast, baDevice, communityData, isUpdate]);

  const onFinish = async (value) => {
    try {
      if (broadcastBoxStatus === 'insert') {
        const addBroadcast = await broadcastBox.create({
          ...value,
          route:
            moment().valueOf().toString() +
            Math.random().toFixed(3).substring(2, 5),
          onPlaying: false,
          onUrgent: value.onUrgent !== undefined,
          onInteraction: value.onInteraction !== undefined,
          waitingTime:
            moment(value.waitingTime).valueOf() -
            moment().startOf('day').valueOf(),
          countDownTime:
            moment(value.countDownTime).valueOf() -
            moment().startOf('day').valueOf(),
          urgentData,
        });
        if (value.broadcastId !== undefined) {
          await axios('/ezcon/api/enableBroadcast', {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: {
              broadcastId: value.broadcastId,
              broadcastBoxsId: [addBroadcast._id],
            },
          });
        }
        message.success('新增成功');
      } else {
        await broadcastBox.patch(editBroadcastBox._id, {
          ...editBroadcastBox,
          ...value,
          urgentData,
          waitingTime:
            moment(value.waitingTime).valueOf() -
            moment().startOf('day').valueOf(),
          countDownTime:
            moment(value.countDownTime).valueOf() -
            moment().startOf('day').valueOf(),
        });
        if (value.broadcastId !== undefined) {
          await axios('/ezcon/api/enableBroadcast', {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: {
              broadcastId: value.broadcastId,
              broadcastBoxsId: [editBroadcastBox._id],
            },
          });
        }
        message.success('更新成功');
      }
      setIsUpdate((pre) => !pre);
      setAddBroadcastBox(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <Button
          className={styles.buttonAdd}
          onClick={() => {
            setOnUrgent(false);
            setOnInteraction(false);
            setAddBroadcastBox(true);
            setBroadcastBoxStatus('insert');
            form.resetFields();
            // form.setFieldValue({
            //   waitingTimeUnit: 'm',
            //   countDownTimeUnit: 'm',
            // });
          }}
        >
          新增公播盒
        </Button>
        <Button
          className={styles.buttonAdd}
          onClick={() => {
            window.location.href = `${window.location.protocol}//${
              window.location.hostname
            }${window.location.port !== '' ? ':3030' : ''}/ezcon/ezbro/#/${
              communityDataArr.englishName
            }`;
          }}
        >
          前往公播總版
        </Button>
        顯示緊急訊息通知時間：
        <TimePicker
          hasClear={false}
          disabled={disabled ? 'disabled' : ''}
          format="mm分鐘ss秒"
          value={moment(
            moment().startOf('day').valueOf() + communityDataArr.urgentTime
          )}
          onOk={async (value) => {
            const newObject = { ...communityDataArr };
            newObject.urgentTime =
              moment(value).valueOf() - moment().startOf('day').valueOf();
            setCommunityDataArr(newObject);
          }}
          onSelect={async (value) => {
            const newObject = { ...communityDataArr };
            newObject.urgentTime =
              moment(value).valueOf() - moment().startOf('day').valueOf();
            setCommunityDataArr(newObject);
          }}
        />
        {disabled ? (
          <Button style={{ marginLeft: 10 }} onClick={() => setDisabled(false)}>
            編輯
          </Button>
        ) : (
          <Button
            style={{ marginLeft: 10 }}
            onClick={async () => {
              try {
                await communityData.patch(communityDataArr._id, {
                  ...communityDataArr,
                });
                setIsUpdate((pre) => !pre);
                message.success('已更新設定參數');
                setDisabled(true);
              } catch (error) {
                message.error('更新失敗');
              }
            }}
          >
            完成
          </Button>
        )}
      </div>

      <Card free>
        <Card.Content>
          <Table
            dataSource={broadcastBoxData}
            sortDirections={['descend', 'ascend', 'descend']}
            bordered
          >
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={150}
              sorter={(a, b) => a.createdTime - b.createdTime}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column title="公播盒名稱" dataIndex="name" width={150} />
            {/* <Table.Column title="編號" dataIndex="route" width={150} /> */}
            <Table.Column
              title="目前播放"
              dataIndex="broadcastId"
              width={150}
              render={(value) => {
                if (value) {
                  return (
                    <div>
                      <span>
                        {
                          broadcastData.find((item) => item._id === value)
                            ?.title
                        }
                        <EditOutlined
                          onClick={() => {
                            const result = broadcastData.find(
                              (item) => item._id === value
                            );
                            if (result?.broadcastGroup) {
                              setTimeout(() => {
                                history.push('/ezpro/broadcast/broadcastGroup');
                              }, 1000);
                            } else {
                              setTimeout(() => {
                                history.push('/ezpro/broadcast/broadcastList');
                              }, 1000);
                            }
                          }}
                        />
                      </span>
                    </div>
                  );
                }
              }}
            />

            <Table.Column
              title="更新時間"
              dataIndex="updatedTime"
              width={150}
              sorter={(a, b) => a.createdTime - b.createdTime}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column
              title="操作"
              width={300}
              lock="right"
              dataIndex="_id"
              render={(value, record) => {
                return (
                  <div className={styles.btn}>
                    {/* 20220512 由於公播前台獨立因此暫時移除前往功能 */}
                    <Button
                      type="primary"
                      onClick={() => {
                        window.location.href = `${window.location.protocol}//${
                          window.location.hostname
                        }${
                          window.location.port !== '' ? ':3030' : ''
                        }/ezcon/ezbro/#/${communityDataArr.englishName}/${
                          record.route
                        }`;
                      }}
                    >
                      前往
                    </Button>
                    <Button
                      type={record.onPlaying ? 'primary' : 'secondary'}
                      onClick={() => {
                        if (record.onPlaying) {
                          axios('/ezcon/api/disableBroadcast', {
                            method: 'POST',
                            headers: {
                              authorization:
                                window.localStorage['feathers-jwt'],
                            },
                            data: { broadcastBoxsId: [value] },
                          })
                            .then(() => {
                              setIsUpdate((pre) => !pre);
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        } else {
                          setAddBroadcastDialog(true);
                          setBroadcastBoxId(value);
                        }
                      }}
                    >
                      {record.onPlaying ? '停止播放' : '開始播放'}
                    </Button>
                    <Button
                      type="normal"
                      onClick={() => {
                        setEditBroadcastBox(record);
                        setBroadcastBoxStatus('update');
                        setAddBroadcastBox(true);
                        setOnUrgent(record.onUrgent);
                        setOnInteraction(record.onInteraction);
                        let newUrgent = {};
                        if (record.onUrgent === false) {
                          newUrgent = {
                            ...record,
                            urgentData: [],
                            urgentDevice: [],
                          };
                        } else {
                          newUrgent = {
                            ...record,
                          };
                        }
                        console.log(newUrgent);
                        form.setFieldsValue({
                          ...newUrgent,
                          waitingTime: moment(
                            moment().startOf('day').valueOf() +
                              record.waitingTime
                          ),
                          countDownTime: moment(
                            moment().startOf('day').valueOf() +
                              record.countDownTime
                          ),
                        });
                      }}
                    >
                      編輯
                    </Button>
                    {user.userGroup.name === 'superAdmin' && (
                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          Swal.fire({
                            title: `確定刪除${record.name}資料?`,
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              broadcastBox.remove(value).then(() => {
                                message.success('刪除成功');
                                setIsUpdate((pre) => !pre);
                              });
                            }
                          });
                        }}
                      >
                        刪除
                      </Button>
                    )}
                  </div>
                );
              }}
            />
          </Table>

          {/* 新增/編輯公播盒 */}
          <Dialog
            hasMask
            className={styles.dialog}
            visible={addBroadcastBox}
            onOk={() => {
              form.submit();
            }}
            onClose={() => {
              setAddBroadcastBox(false);
            }}
            onCancel={() => {
              setAddBroadcastBox(false);
            }}
          >
            <h3>
              {broadcastBoxStatus === 'insert' ? '新增' : '修改'}公播盒列表
            </h3>
            <Form
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              form={form}
              onFinish={onFinish}
            >
              <Form.Item
                name="name"
                label="名稱"
                rules={[
                  {
                    required: true,
                    message: '請輸入公播盒名稱',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="category"
                label="類別"
                rules={[
                  {
                    required: true,
                    message: '請選擇公播盒類別',
                  },
                ]}
              >
                <Select style={{ width: '200px' }}>
                  <Option value="研華">研華</Option>
                  <Option value="EZTVBox">EZTVBox</Option>
                  <Option value="其他">其他</Option>
                </Select>
              </Form.Item>
              {selectedValue === 'EZTVBox' && (
                <>
                  <Form.Item
                    name="MAC"
                    label="MAC"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="quality"
                    label="畫質"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Radio.Group>
                      <Radio id="normal" value="高畫質">
                        高畫質
                      </Radio>
                      <Radio id="oneDayLimit" value="低畫質">
                        低畫質
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </>
              )}
              <Form.Item
                name="broadcastId"
                label="公播播放內容"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select allowClear={false} style={{ width: '200px' }}>
                  {broadcastData.map((item) => {
                    return (
                      <Option key={item._id} value={item._id}>
                        {item.title}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item
                name="onUrgent"
                label="公播通知"
                valuePropName="checked"
              >
                <Switch onChange={(value) => setOnUrgent(value)} />
              </Form.Item>
              {(form.getFieldValue('onUrgent') || onUrgent) && (
                <>
                  <Form.Item
                    name="urgentDevice"
                    label="公播通知裝置"
                    rules={[
                      {
                        required: true,
                        message: '請選擇公播通知裝置',
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: '200px' }}
                      onChange={(value) => {
                        console.log(value);
                        const newUrgentData = [];
                        for (let i = 0; i < value.length; i++) {
                          baDevice
                            .find({ query: { name: value[i] } })
                            .then((res) => {
                              newUrgentData.push({
                                baName: value[i],
                                broadcast: res.data[0].broadcastType,
                                playType: res.data[0].playType,
                              });
                            });
                        }
                        setUrgentData(newUrgentData);
                      }}
                    >
                      {baDeviceData.map((item) => {
                        return (
                          <Option key={item.name} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </>
              )}
              <Form.Item
                name="onInteraction"
                label="互動式屏"
                valuePropName="checked"
              >
                <Switch onChange={(value) => setOnInteraction(value)} />
              </Form.Item>
              {(form.getFieldValue('onInteraction') || onInteraction) && (
                <>
                  <Form.Item
                    name="waitingTime"
                    label="顯示時間"
                    rules={[
                      {
                        required: true,
                        message: '請選擇互動屏顯示時間',
                      },
                      () => ({
                        async validator(_, value) {
                          if (
                            value.startOf('s').valueOf() -
                              moment().startOf('day').valueOf() >=
                            5000
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('時間需超過5秒'));
                        },
                      }),
                    ]}
                  >
                    <TimePicker
                      // popupStyle={}
                      format="mm分鐘ss秒"
                      allowClear={false}
                      onSelect={(value) => {
                        form.setFieldValue('waitingTime', value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="countDownTime"
                    label="退出時間"
                    rules={[
                      {
                        required: true,
                        message: '請選擇互動屏倒數時間',
                      },
                      () => ({
                        async validator(_, value) {
                          if (
                            value.startOf('s').valueOf() -
                              moment().startOf('day').valueOf() >=
                            5000
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('時間需超過5秒'));
                        },
                      }),
                    ]}
                  >
                    <TimePicker
                      format="mm分鐘ss秒"
                      allowClear={false}
                      onSelect={(value) => {
                        form.setFieldValue('countDownTime', value);
                      }}
                    />
                  </Form.Item>
                </>
              )}
            </Form>
          </Dialog>

          {/* 播放公播 */}
          <Dialog
            hasMask
            className={styles.dialog}
            visible={addBroadcastDialog}
            onOk={() => {
              // form.submit();
              const newRecord = {
                broadcastId: addBroadcast,
                broadcastBoxsId: [broadcastBoxId],
              };

              axios('/ezcon/api/enableBroadcast', {
                method: 'POST',
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
                data: newRecord,
              })
                .then(() => {
                  message.success('設定成功');
                  setIsUpdate((pre) => !pre);
                  setAddBroadcastDialog(false);
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
            onClose={() => {
              setAddBroadcastDialog(false);
            }}
            onCancel={() => {
              setAddBroadcastDialog(false);
            }}
          >
            <h3>選擇播放公播名稱</h3>
            <RadioGroup
              itemDirection="ver"
              // value={}
              onChange={(value) => setAddBroadcast(value)}
              aria-labelledby="groupId"
            >
              {broadcastData.map((item, index) => (
                <Radio id={index} value={item._id} key={item._id}>
                  {item.title}
                </Radio>
              ))}
            </RadioGroup>
          </Dialog>
        </Card.Content>
      </Card>
    </>
  );
};

export default BroadCastBoxList;
